import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const TeamApi = createApi({
  reducerPath: "TeamApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["TEAMAPI"],
  endpoints: (build) => ({
    getTeam: build.query({
      query: ({ page, searchTerm }) => ({
        url: `/team?page=${page}&search=${searchTerm}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["TEAMAPI"],
    }),

    getTeamById: build.query({
      query: ({ id }) => ({
        url: `/team/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["TEAMAPI"],
    }),

    editTeam: build.mutation({
      query: ({ id, data }) => ({
        url: `/team/${id}`,
        method: "PUT",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["TEAMAPI"],
    }),

    addTeam: build.mutation({
      query: ({ data }) => ({
        url: `/team`,
        method: "POST",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["TEAMAPI"],
    }),

    deleteTeam: build.mutation({
      query: ({ id }) => ({
        url: `/team/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["TEAMAPI"],
    }),
  }),
});

export const {
  useGetTeamQuery,
  useGetTeamByIdQuery,
  useEditTeamMutation,
  useAddTeamMutation,
  useDeleteTeamMutation,
} = TeamApi;